/**
 * Returns a number based on old code from rateGenius
 *
 * @param {number} numberOfmonths
 * @returns {number}
 */

export const toRateGeniusValue = (numberOfmonths = 0) => {
  return numberOfmonths >= 24 ? 2 : 1;
};
